import { useRef } from "react";
import { UploadSvg } from "../../svgFiles/UploadSvg";

const MAX_SIZE_MB = 10;

export default function VaFileInput({
  id,
  label,
  required = false,
  optional = false,
  accept = "application/pdf,.pdf",
  allowImages = false,
  file,
  onFileSelect,
  error,
  emptyLabel = "No file chosen",
  showUploadIcon = false,
  labelClassName = "",
}) {
  const inputRef = useRef(null);
  const displayName = file?.name || emptyLabel;

  const handleChange = (e) => {
    const selected = e.target.files?.[0];
    if (!selected) {
      onFileSelect?.(null);
      return;
    }

    const name = selected.name.toLowerCase();
    const isPdf =
      selected.type === "application/pdf" || name.endsWith(".pdf");
    const isImage =
      selected.type.startsWith("image/") ||
      /\.(jpe?g|png|webp)$/i.test(name);
    if (allowImages ? !isPdf && !isImage : !isPdf) {
      onFileSelect?.(
        null,
        allowImages
          ? "Only PDF or image files are allowed."
          : "Only PDF files are allowed."
      );
      e.target.value = "";
      return;
    }
    if (selected.size / 1024 / 1024 > MAX_SIZE_MB) {
      onFileSelect?.(null, `File exceeds ${MAX_SIZE_MB} MB limit.`);
      e.target.value = "";
      return;
    }

    onFileSelect?.(selected, "");
  };

  return (
    <div className="va-file-field">
      {label ? (
        <label
          htmlFor={id}
          className={`va-file-field__label ${labelClassName}`.trim()}
        >
          {label}
          {required && <span className="va-file-field__required"> *</span>}
          {optional && (
            <span className="va-file-field__optional"> (Optional)</span>
          )}
        </label>
      ) : null}
      <div
        className="va-file-input"
        role="button"
        tabIndex={0}
        onClick={() => inputRef.current?.click()}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            inputRef.current?.click();
          }
        }}
      >
        <button
          type="button"
          className="va-file-input__btn"
          onClick={(event) => {
            event.stopPropagation();
            inputRef.current?.click();
          }}
        >
          Choose files
        </button>
        <span
          className={`va-file-input__name${file ? " va-file-input__name--selected" : ""}`}
          title={displayName}
        >
          {displayName}
        </span>
        {showUploadIcon ? (
          <span className="va-file-input__icon" aria-hidden="true">
            <UploadSvg />
          </span>
        ) : null}
        <input
          ref={inputRef}
          id={id}
          type="file"
          accept={accept}
          className="va-file-input__native"
          onChange={handleChange}
        />
      </div>
      {error && <p className="va-file-field__error">{error}</p>}
    </div>
  );
}
